import { createContext } from 'react';
import type { IAttachmentStateItem } from '@services/attachmentChanges/attachmentChanges.types';

export interface IAttachmentLocateRequest {
    id: number;
    tabKey: string;
    tableKey: string;
    items: IAttachmentStateItem[];
}

export interface IDocumentAttachmentChanges {
    documentId: string;
    revision?: string;
    items?: IAttachmentStateItem[];
    request?: IAttachmentLocateRequest;
    markViewed: (tableKey: string, contentToken: string, visibleKeys: string[]) => void;
    handled: (id: number) => void;
    unread?: IAttachmentStateItem[];
    revealUnread?: (tableKey: string) => void;
}

export const DocumentAttachmentChangesContext = createContext<IDocumentAttachmentChanges | undefined>(undefined);
